import { render, staticRenderFns } from "./packaging-inputs.vue?vue&type=template&id=2099e2a2&"
import script from "./packaging-inputs.vue?vue&type=script&lang=js&"
export * from "./packaging-inputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports